import { RefObject, useEffect, useRef } from 'react';

export const useOutsideClick = <T extends HTMLElement>(
  callback: (event: MouseEvent | TouchEvent) => void
): RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [callback]);

  return ref as RefObject<T>;
};
